var Shopify = Shopify || {};
const product = JSON.parse(document.querySelector('[data-product-id]').textContent);
const amount_with_comma_separator = '{{amount_with_comma_separator}}';
const varianten = document.querySelectorAll('[data-variant]');
const optionsSize = parseInt(document.querySelector('[data-options-size]').getAttribute('data-options-size'));
const quantityInput = document.querySelector('.quantity-input');
const crossselling = document.querySelectorAll('.crossselling-product');
const addToCartForm = document.querySelector('form[id="add-to-cart"]');
const stocks = document.querySelectorAll('input[name="variant-stock"]');

// Pre-order (snippets/preorder.liquid): welke varianten pre-order zijn en welke regel-eigenschap erbij hoort
const preorderEl = document.getElementById('godu-preorder-data');
const preorder = preorderEl ? JSON.parse(preorderEl.textContent) : { variants: [] };
const isPreorderVariant = (id) => preorder.variants.includes(Number(id));

const stickyAtcBtn = document.querySelector('.sticky-atc-btn');
const stickyAtcQty = document.querySelector('.sticky-atc-qty');

stickyAtcQty?.addEventListener('change', function() {
  var quantityField = document.querySelector(`input[name="quantity-second"]`);
  var stickyQuantity = this.value; 
  quantityField.value = stickyQuantity;
});

stickyAtcBtn?.addEventListener('click', function(event) {
    event.preventDefault();
    addToCartForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
});

const stocksMap = {};
var currentOptions = {};

// stocks
stocks.forEach((stock) => {
  const variantId = stock.value;
  const stockValue = parseInt(stock.getAttribute('data-stock'));
  stocksMap[variantId] = stockValue;
});

// Add to cart
if (addToCartForm) {
  addToCartForm.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(addToCartForm);
    const productId = formData.get('id');
    const productQty = formData.get('quantity-second');

    const mainItem = {
      id: productId,
      quantity: parseInt(productQty, 10),
    };
    if (isPreorderVariant(productId)) {
      mainItem.properties = { [preorder.name]: preorder.value };
    }
    const items = [mainItem];

     crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        const variantId = checkbox.getAttribute('data-variant-id');
        const crossellingQty = 1

        if (crossellingQty > 0) {
          items.push({
            id: variantId,
            quantity: parseInt(crossellingQty, 10),
          });
        }
      }
    });

    if (items) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => response.json())
        .then(() => {
      // Second: fetch the full cart
      return fetch("/cart.js", {
        headers: {
          "Accept": "application/json",
        },
      }).then((res) => res.json());
    })
    .then((cart) => {
      console.log("Updated cart:", cart);
      document.dispatchEvent(new CustomEvent('godu:cart:add')); // opent de cart-drawer
      updateSmallcart();
    })
    .catch((err) => {
      console.error("Fetch error:", err);
    });
    }
  });
}

// variants
if (varianten) {
  varianten.forEach((variant) => {
    ['click', 'change'].forEach((event) => {
        variant.addEventListener(event, () => handleVariantChange(variant));
    });
  });
}

// Crossselling
if (crossselling) {
  crossselling.forEach(function (product) {
    handleCrosssellingChange(product);
  });
}

function handleVariantChange(variant) {
  // First get the option name
  const optionName = variant.getAttribute('data-name');

  // Second get the option value based on the type
  if (variant.tagName == 'SELECT') {
    const selectedOption = variant.options[variant.selectedIndex];
    var optionValue = selectedOption.getAttribute('data-value');
  } else {
    var optionValue = variant.getAttribute('data-value');
  }

  // Check if optionValue is not null
  if (optionValue !== null) {
    // Create object with the values
    currentOptions[optionName] = optionValue;

    // Create active state on the click elements (only on inputs)
    if (variant.tagName == 'SPAN') {
      var allInputs = document.querySelectorAll(`[data-name="${optionName}"]`);
      var input = document.querySelector(`[data-name="${optionName}"][data-value="${currentOptions[optionName]}"]`);
      var label = input;

      // Remove all class actives from the currently clicked labels
      allInputs.forEach((item) => {
        var parentItem = item;
        parentItem.classList.remove('variant-active');
      });

      // Add class active to the clicked label
      label.classList.add('variant-active');
    }

    // Update the current stock and price
    if (currentOptions) {
      updateCurrentOptions(currentOptions, true);
    }
  }
}

function handleCrosssellingChange(product) {
  const checkbox = product.querySelector('input[type="checkbox"]');

  checkbox?.addEventListener('change', () => {
    updatePriceWithCrossselling();
  });
}

function updateCurrentOptions(currentOptions, showVariantImage) {
  var option1 = currentOptions['option1'] || 'Default Title';
  var option2 = currentOptions['option2'] || '';
  var option3 = currentOptions['option3'] || '';

  // Check how many variants are available
  switch (optionsSize) {
    case 3:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2 && variant.option3 == option3
      );
      break;
    case 2:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2
      );
      break;
    case 1:
      var currentOption = product.variants.filter((variant) => variant.option1 === option1);
      break;
  }

  if (currentOption[0] !== undefined) {
    var id = currentOption[0].id;
    var price = currentOption[0].price;
    var compare_at_price = currentOption[0].compare_at_price;
    var stock = stocksMap[id] || 0;

    updatePriceWithStock(price, compare_at_price, stock, id, showVariantImage);
  }
}

function updatePriceWithStock(price, compare_at_price, stock, id, showVariantImage) {
  // Volume discount check
  const volumeDiscountContainer = document.querySelector('#volume-discount-container');
  var priceExcl = price;
  var comparePriceExcl = compare_at_price;
  var discountedPriceExcl = 0;

  // Update for the price
  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.querySelector('.compare-at-price');
  const currentPriceExcl = document.querySelector('.current-price-excl');
  const currentSavedPrice = document.querySelector('.current-saved-price');
  const quantity = parseInt(quantityInput.value, 10);
  var totalPrice = price;

  var totalPriceExcl = priceExcl;
  var totalComparePrice = compare_at_price;
  var totalComparePriceExcl = comparePriceExcl;

  if (currentPrice) {
    currentPrice.setAttribute('data-solo-price', price);
    currentPrice.setAttribute('data-price', priceExcl);
    currentPrice.setAttribute('data-stock', stock);
    currentPrice.setAttribute('data-excl-price', totalPriceExcl);

    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-excl-price', totalComparePriceExcl);
    }
  }

  setTimeout(() => {
    const prettyPrice = Shopify.formatMoney(totalPrice, amount_with_comma_separator);
    const prettyPriceExcl = Shopify.formatMoney((totalPrice / 1.21), amount_with_comma_separator);
    const prettyComparePrice = Shopify.formatMoney(totalComparePrice, amount_with_comma_separator);
    const prettyDiscountedPrice = Shopify.formatMoney(discountedPriceExcl, amount_with_comma_separator);
    const prettySavedPrice = Shopify.formatMoney((totalComparePrice - totalPrice), amount_with_comma_separator);

    if (currentPrice) {
      // This statements checks the bundler app
      if (!volumeDiscountContainer) {
        currentPrice.innerHTML = `${prettyPrice}`;
      } else {
        if (discountedPriceExcl > 0) {
          currentPrice.innerHTML = `${prettyDiscountedPrice}`;
        } else {
          currentPrice.innerHTML = `${prettyPrice}`;
        }
      }
    }

    if (currentComparePrice) {
      currentComparePrice.setAttribute('data-compare-price', compare_at_price);
      // This statements checks the bundler app
      if (totalComparePrice !== 0) {
        if (currentComparePrice.classList.contains('hidden')) {
            currentComparePrice.classList.remove('hidden');
            currentComparePrice.classList.add('flex');
        }
        if (!volumeDiscountContainer) {
            currentComparePrice.innerHTML = `${prettyComparePrice}`;
        } else {
            currentComparePrice.innerHTML = `${prettyComparePrice}`;
        }
      } else {
        currentComparePrice.classList.add('hidden');
      }
    }

    if (currentPriceExcl) {
        currentPriceExcl.innerHTML = `${prettyPriceExcl} excl. BTW`;
    }

    if (currentSavedPrice) {
        if (totalComparePrice) {
            if (currentSavedPrice.classList.contains('hidden')) {
                currentSavedPrice.classList.remove('hidden');
            }
            currentSavedPrice.innerHTML = `${prettySavedPrice} bespaard`;
        } else {
            currentSavedPrice.classList.add('hidden');
        }
    }

    // Update for the stock
    const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
    const outOfStockBtn = document.querySelector('[data-out-of-stock-button]');

    const toggleClass = (element, removeClass, addClass) => {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    };

    // Pre-order: kaart, label en knoptekst hangen aan .is-preorder (assets/preorder.css)
    const isPreorder = isPreorderVariant(id);
    addToCartForm?.closest('.section-wrapper')?.classList.toggle('is-preorder', isPreorder);

    if (!isPreorder && (stock <= 0 || stock < quantity)) {
      toggleClass(addToCartBtn, 'flex', 'hidden');
      toggleClass(outOfStockBtn, 'hidden', 'flex');
    } else {
      toggleClass(addToCartBtn, 'hidden', 'flex');
      toggleClass(outOfStockBtn, 'flex', 'hidden');
    }

    // Update the select with the stock (pre-order: tot 30, zoals de pagina zelf bij doorverkopen)
    if (stock > 0 || isPreorder) {
        const maxQty = stock > 0 ? stock : 30;
        quantityInput.innerHTML = '';
        for (let i = 1; i <= maxQty; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i === quantity) {
              option.selected = true;
            }
            quantityInput.appendChild(option);
        }
    } else {
        quantityInput.innerHTML = '';
        for (let i = 0; i <= 0; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            quantityInput.appendChild(option);
        }
    }

    // Update the variant ID for the add to cart button
    var variantId = document.querySelector(`input[name="id"]`);
    variantId.value = id;

    // Update the quantity for the add to cart button
    var quantityField = document.querySelector(`input[name="quantity-second"]`);
    quantityField.value = quantity;
  }, 250);
}

function updatePriceWithCrossselling() {
  const currentPrice = document.querySelector('.current-price');
  const quantity = parseInt(quantityInput.value, 10);
  var priceExcl = currentPrice.getAttribute('data-price');
  var totalPriceExcl = priceExcl * quantity;

  if (crossselling) {
    crossselling.forEach(function (product) {
      const checkbox = product.querySelector('input[type="checkbox"]');

      if (checkbox && checkbox.checked) {
        const crosssellingQuantity = 1;
        const crosssellingPrice = parseFloat(
          product.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        totalPriceExcl += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  const prettyPrice = Shopify.formatMoney(totalPriceExcl, amount_with_comma_separator);
  if (currentPrice) {
    //currentPrice.setAttribute('data-excl-price', totalPriceExcl);
    //currentPrice.innerHTML = `${prettyPrice}`;
  }
}

function setupQuantityControls() {
  if (!quantityInput) return;

  quantityInput.addEventListener('change', () => {
    if (currentOptions) {
      updateCurrentOptions(currentOptions, false);
    }
  });
}

function showCartNotification(shoppingcart, added) {
  const miniCarts = document.querySelectorAll('.mini-cart');

  miniCarts.forEach(miniCart => {
     const miniCartItems = miniCart.querySelector('.mini-cart-items');

    // Make sure mini cart is visible
    miniCart.classList.remove('hidden');

    // Clear old content
    miniCartItems.innerHTML = '';

    if ('items' in shoppingcart && shoppingcart.items.length > 0) {
      shoppingcart.items.forEach((item) => {
        const itemDiv = document.createElement("div");
        itemDiv.className = "flex justify-between items-center gap-4 py-4";

        const leftDiv = document.createElement("div");
        leftDiv.className = "flex items-center gap-4";

        const img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title;
        img.className = "w-10 h-10 object-cover rounded-[4px]";

        const titleP = document.createElement("p");
        titleP.className = "text-xs";
        titleP.textContent = item.title;

        leftDiv.appendChild(img);
        leftDiv.appendChild(titleP);

        const priceSpan = document.createElement("span");
        priceSpan.className = "text-sm font-bold";
        priceSpan.textContent = Shopify.formatMoney(item.line_price).replace(/[^0-9,.]/g, ""); 
        // stripping currency if you want `money_without_currency`

        itemDiv.appendChild(leftDiv);
        itemDiv.appendChild(priceSpan);

        miniCartItems.appendChild(itemDiv);
      });

      // Add total + link
      const totalDiv = document.createElement("div");
      totalDiv.className = "flex justify-between items-center font-bold mt-2 pt-4 border-t border-b-[#d8dbe0]";
      totalDiv.innerHTML = `Totaal: <span>${Shopify.formatMoney(shoppingcart.total_price).replace(/[^0-9,.]/g, "")}</span>`;

      // Add button
      const cartLink = document.createElement("a");
      cartLink.href = "/cart";
      cartLink.className = "btn btn-light-green w-full mt-4";
      cartLink.textContent = "Naar winkelwagen";

      miniCartItems.appendChild(totalDiv);
      miniCartItems.appendChild(cartLink);
    } else {
      // Empty cart message
      const emptyP = document.createElement("p");
      emptyP.textContent = "Je winkelwagen is leeg.";
      miniCartItems.appendChild(emptyP);
    }
  });
}

function hideCartNotification() {
  const miniCarts = document.querySelectorAll('.mini-cart');
  miniCarts.forEach(miniCart => {
    miniCart.classList.add('hidden');
    const miniCartItems = miniCart.querySelector('.mini-cart-items');
    if (miniCartItems) miniCartItems.innerHTML = '';
  });
}

async function updateSmallcart() {
  const cart_counts = document.querySelectorAll('.cart-count p');

  try {
    // Fetch the latest cart data
    const cart = await fetchCartItems();

    if (cart) {
      const item_count = cart.item_count;
      cart_counts.forEach(el => {
        el.textContent = item_count;
      });
    }
  } catch (error) {
    console.error('Error updating small cart:', error);
  }
}

async function fetchCartItems() {
  try {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error('Something wrongs');
    }
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      console.log('Empty cart, refetching...');
      return await fetchCartItems();
    }
    return cart;
  } catch (error) {
    console.error('Fetch error:', error);
  }
}

document.addEventListener('DOMContentLoaded', setupQuantityControls);